export const initData = {
  firstName: 'tony',
  lastName: 'nguyen',
  location: [
    {
      address: '140',
      district: 'phunhuan',
      city: 'hcm'
    },
    {
      address: '220',
      district: 'govap',
      city: 'phuquoc'
    },
    {
      address: '500',
      district: 'binhthanh',
      city: 'hanoi'
    },
  ]
}